import { lazyVue } from "@/utils";
export default [{
    path: '/bindCard',
    name: 'bindCard',
    title: '申请绑定会员',
    component: lazyVue('my/bindCard/index'),
    meta: {
        // showBar:1,
        title: '申请绑定会员',
        name: '申请绑定会员'
    }
}]


// WEBPACK FOOTER //
// ./src/router/bindCard/index.js